// extracted by mini-css-extract-plugin
export default {"overlay":"GetPix_overlay__bjB0p","alert":"GetPix_alert__awvF7","pix":"GetPix_pix__B5yqI"};